import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    ['@media (max-width: 768px)']: {
      flexDirection: "column-reverse"
    },
  },
}));

const FormWrapper = props => {
  const classes = blockStyles();

  const { className, children } = props;
  return (
    <div className = { clsx(classes.root, className) } >
      { children }
    </div>
  );
};

export default FormWrapper;